import { put, post } from "src/services/api";

const GENERATE_SPEECH_ENDPOINT = "/assistants/generate-speech";
const ADMIN_GENERATE_SPEECH_ENDPOINT = "/admin/assistants/generate-speech";

const generateSpeech = async ({ text, voiceName, speakingRate, pitch, isAdmin = false, signal }) => {
  const payload = {
    text,
    voiceName,
    speakingRate: speakingRate ?? 1.0,
    pitch: pitch ?? 0.0
  };

  const response = isAdmin
    ? await post({ endpoint: ADMIN_GENERATE_SPEECH_ENDPOINT, data: payload, responseType: "arraybuffer", signal })
    : await put({ endpoint: GENERATE_SPEECH_ENDPOINT, data: payload, responseType: "arraybuffer", signal });

  const audioBlob = new Blob([response], { type: "audio/wav" });
  return audioBlob;
};

export default {
  generateSpeech
};

